import type { TemplateOnlyComponent } from '@ember/component/template-only';

const CoachingConfigsTemplate: TemplateOnlyComponent = <template>
  {{outlet}}
</template>;

export default CoachingConfigsTemplate;
